import Head from "next/head";
import { Content, GoogleJobsSchema } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { getGlobal } from "@/functions/getGlobal";
import { jobs_helper } from "@/helpers/jobs_helper";
import { consultant_helper } from "@/helpers/consultant_helper";
import * as additionalComponents from "./__components";
import { createTitle } from "@/functions/createTitle";
import BackButton from "@/components/BackButton";
import JobDetail from "@/components/JobDetail";
import LatestJobs from "@/components/LatestJobs";
import classes from "./styles.module.scss";
import SeoHead from "@/components/SeoHead";
import { getEmploymentType } from "@/functions/getEmploymentType";
import { getFirstLocation } from "@/functions/getFirstLocation";
import { getJobTypeLabel } from "@/functions/getJobTypeLabel";
import { getMetaDescription } from "@/functions/getMetaDescription";

export default function JobPage({ job, all_jobs, consultant, content }) {
  const global = getGlobal();

  // Meta title uses the first location entered only, plus the job type: "Job in Brussels | Contract Role"
  const meta_location = getFirstLocation(job?.location);
  const meta_job_type = getJobTypeLabel(job?.categories);
  const meta_title = [
    meta_location ? `${job?.title} Job in ${meta_location}` : `${job?.title} Job`,
    meta_job_type && `${meta_job_type} Role`,
    "EarthStream",
  ]
    .filter(Boolean)
    .join(" | ")
    .replace(/\s+/g, " "); // some job titles carry stray whitespace from the CMS
  const meta_description = getMetaDescription(job?.description, 260);

  return (
    <>
      <main style={{ marginTop: "200px" }}>
        <GoogleJobsSchema
          job={job}
          employment_type={getEmploymentType(job.categories)}
          site_name={global["_theme.company.name"]}
          site_domain_link={global["_theme.company.domain"]}
          site_google_logo_link={global["_theme.company.logo"]}
        />
        <SeoHead
          page_name={meta_title}
          description={meta_description || undefined}
          canonical_link={`https://www.earthstreamglobal.com/jobs/${job?.url_slug}`}
        />
        <div className={classes.cont}>
          <BackButton link="/jobs" />
          <JobDetail job={job} consultant={consultant ? consultant : {}} />
        </div>
        <LatestJobs jobs={all_jobs} title=""></LatestJobs>
      </main>
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const job = jobs_helper.find(url_slug);
  let related = jobs_helper.fetch({ exclude: [job.id] }); // TODO filter by sector
  if (!related || related.length == 0) {
    related = jobs_helper.fetch().slice(0, 4);
  }

  const consultant_category = job.categories.find((c) => c.id === "5dd1c75d-e576-49e4-8e06-58c6cdebae5a");
  const consultant_detail = consultant_category?.values.shift();
  const consultant_name = (consultant_detail?.name || "").toUpperCase();

  const consultant =
    consultant_helper.fetch({ filter: (i) => i.name.toUpperCase() == consultant_name }).shift() ?? null;

  return {
    props: {
      meta: {
        title: createTitle(job.title),
      },
      job,
      all_jobs: related,
      consultant,
    },
  };
}

export async function getStaticPaths() {
  return { paths: jobs_helper.toPaths(), fallback: false };
}
